const getInitials = (fullName)=>{
    var _ref, _ref1;
    var _parts_, _parts_1;
    if (!fullName) return '';
    const parts = fullName.trim().split(/\s+/);
    const first = null != (_ref = null == (_parts_ = parts[0]) ? void 0 : _parts_[0]) ? _ref : '';
    const second = null != (_ref1 = null == (_parts_1 = parts[1]) ? void 0 : _parts_1[0]) ? _ref1 : '';
    return first + second;
};
export { getInitials };
